// extracted by mini-css-extract-plugin
export var formContainer = "_m7-0";
export var message = "_m7-1";